export enum HttpStatus {
    Success,
    Error,
    Offline
}